function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBookmark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 409,
  height: 145,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#F7F8FA",
  fillRule: "evenodd",
  d: "M332.88 3C340.126 3 346 8.104 346 14.4s-5.874 11.4-13.12 11.4h-74.97c7.246 0 13.12 5.104 13.12 11.4s-5.874 11.4-13.12 11.4h41.234c7.246 0 13.119 5.104 13.119 11.4s-5.873 11.4-13.119 11.4h-19.069c-9.136 0-16.542 5.104-16.542 11.4q0 6.295 11.245 11.4c7.246 0 13.12 5.104 13.12 11.4s-5.874 11.4-13.12 11.4H119.216c-7.246 0-13.12-5.104-13.12-11.4s5.874-11.4 13.12-11.4H46.12C38.874 94.2 33 89.096 33 82.8s5.874-11.4 13.12-11.4h74.97c7.246 0 13.12-5.104 13.12-11.4s-5.874-11.4-13.12-11.4H74.234c-7.246 0-13.12-5.104-13.12-11.4s5.874-11.4 13.12-11.4h74.97c-7.246 0-13.12-5.104-13.12-11.4S141.958 3 149.204 3zm0 45.6c7.246 0 13.12 5.104 13.12 11.4s-5.874 11.4-13.12 11.4-13.12-5.104-13.12-11.4 5.874-11.4 13.12-11.4",
  clipRule: "evenodd",
  style: {
    fill: "#f7f8fa",
    fill: "color(display-p3 .9702 .9735 .98)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#476CFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeOpacity: 0.1,
  strokeWidth: 7.5,
  d: "M379.403 27h-13.865m24.591-23H361zM402 4h-3.767zM99 141H82.083m7.242-26h-35.54zm-47.59 0H33z",
  style: {
    stroke: "#476cff",
    stroke: "color(display-p3 .2784 .4235 1)",
    strokeOpacity: 0.1
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#476CFF",
  fillOpacity: 0.24,
  d: "M226 35.625a9.565 9.565 0 0 1 9.562 9.563v6.374h-6.374v38.25a9.564 9.564 0 0 1-9.563 9.563H175a9.565 9.565 0 0 1-9.562-9.562v-6.376h51v6.376a3.185 3.185 0 0 0 2.814 3.165l.373.022a3.19 3.19 0 0 0 3.165-2.815l.022-.373V42h-41.437a3.19 3.19 0 0 0-3.165 2.815l-.022.373v31.874h-6.376V45.189a9.564 9.564 0 0 1 9.563-9.563z",
  style: {
    fill: "#476cff",
    fill: "color(display-p3 .2784 .4235 1)",
    fillOpacity: 0.24
  }
}));
export { SvgBookmark as ReactComponent };
export default __webpack_public_path__ + "f6a03f95b933f8682aabe828c25d7bc9.svg";